import React from "react";
import { useApiClient } from "../../../../shared/customHooks";
import { kindergartenFormLegacy } from "../../../../shared/formObjects/application/legacy/kindergartenFormLegacy";
import { useApplicationContext } from "../../context/applicationContext";
import BaseApplicationComponent from "../../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function KindergartenComponentLegacy({ disabled, data }: any) {
  const api = useApiClient("Kinder");
  const { id } = useApplicationContext();

  return (
    <BaseApplicationComponent
      formBody={kindergartenFormLegacy}
      headerLabel="Kindergarten Details"
      editPath="kindergarten"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
    />
  );
}

export default KindergartenComponentLegacy;
